import { useState } from 'react'
import { USIndicator } from '~/entities/reviewer'
import type { apiClient } from '~/shared/api/data-ingestion-api'
import { formatDateDefault } from '~/shared/lib/datetime'
import {
  IconButton,
  Popover,
  PopoverAnchor,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '~/shared/ui'

export function DocumentCard({ document }: { document: apiClient.Document }) {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <div className="flex items-center gap-0.5">
        {document.onshore_only && <USIndicator />}
        <PopoverAnchor asChild>
          <div className="ml-2 flex items-center gap-2">
            <div className="flex flex-col">
              <Text
                appearance="BODY2"
                className="uppercase"
                copyable
              >
                {document.key}
              </Text>
              <Text
                className="text-text-secondary uppercase"
                appearance="CAPTION"
                copyable
                copyTooltipSide="bottom"
              >
                {document.cns_key}
              </Text>
            </div>
            <PopoverTrigger
              asChild
              onClick={() => setIsOpen(!isOpen)}
            >
              <IconButton
                materialIcon={isOpen ? 'arrow_drop_up' : 'arrow_drop_down'}
                size="small"
                container="small"
              />
            </PopoverTrigger>
          </div>
        </PopoverAnchor>
      </div>
      <PopoverContent
        className="w-[300px] p-3"
        align="start"
      >
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <Text
              className="uppercase"
              appearance="SUBTITLE2"
            >
              {document.key}
            </Text>
            {document.onshore_only && <USIndicator />}
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div className="flex flex-col py-1">
              <Text
                className="text-text-secondary"
                appearance="BODY2"
              >
                Consignment
              </Text>
              <div className="flex items-center gap-2">
                <Text
                  className="uppercase"
                  appearance="BODY2"
                >
                  {document.cns_key}
                </Text>
                {document.onshore_only && <USIndicator />}
              </div>
            </div>

            <div className="flex flex-col py-1">
              <Text
                className="text-text-secondary"
                appearance="BODY2"
              >
                Document Pages
              </Text>
              <Text appearance="BODY2">
                {document.page_range.start_page === document.page_range.end_page
                  ? document.page_range.start_page + 1
                  : `${document.page_range.start_page + 1}-${document.page_range.end_page + 1}`}
              </Text>
            </div>
          </div>
        </div>

        <div className="bg-divider my-1 h-px" />

        {document.inbox_info?.date ? (
          <div className="flex flex-col py-1">
            <Text
              className="text-text-secondary"
              appearance="BODY2"
            >
              Date Received
            </Text>
            <Text appearance="BODY2">{formatDateDefault(document.inbox_info.date)}</Text>
          </div>
        ) : null}

        <div className="bg-divider my-1 h-px" />

        {document.inbox_info ? (
          <div className="flex flex-col gap-1 py-1">
            <Text
              className="text-text-secondary"
              appearance="BODY2"
            >
              Inbox
            </Text>

            <div className="grid grid-cols-2 gap-2">
              <div className="flex flex-col">
                <Text
                  className="text-text-secondary"
                  appearance="BODY2"
                >
                  Lockbox Name
                </Text>
                <Text appearance="BODY2">{document.inbox_info.name}</Text>
              </div>

              <div className="flex flex-col">
                <Text
                  className="text-text-secondary"
                  appearance="BODY2"
                >
                  Source
                </Text>
                <Text appearance="BODY2">{document.inbox_info.src}</Text>
              </div>
            </div>
          </div>
        ) : null}
      </PopoverContent>
    </Popover>
  )
}
